module.exports = __webpack_public_path__ + "media/images/admin/icons/navigation-2-52b18e1ec557907e0b4ed2c0395a7222.svg";